import React from 'react';

import { Room } from '../contexts/TransientRooms';
import styles from './transientRoomComponent.scss';
import AddToWebsite from '../../../components/TansientRoomRailCard/AddToWebsite';

interface Props {
  room: Room;
  onClick: (room: Room) => void;
}

const TransientRoomComponent: React.FC<Props> = ({ room, onClick }) => {
  const { propertyId, imagePath, profileUrl, propertyName, price } = room;
  return (
    <div className={styles.room}>
      <a href={profileUrl} target="_blank" className={styles.roomImage} rel="noopener noreferrer">
        {imagePath && <img src={imagePath} alt={propertyName} />}
      </a>
      <div className={styles.details}>
        <div className={styles.propertyName}>{propertyName}</div>
        {price > 0 && <div className={styles.price}>from ${price.toFixed(2).toLocaleString()}</div>}
        <AddToWebsite propertyId={propertyId} onClick={(): void => onClick(room)} />
      </div>
    </div>
  );
};

export default TransientRoomComponent;
